import React, { useState, useEffect } from 'react';
import { Container, Grid, Loader, Input, Image, Dropdown, Button } from "semantic-ui-react"
import grabNFT from '../Classes/grabNFT.js'
import MenuDisp from './menu.js';

import works_grabatar from '../Images/work-grabatar.png'
import works_legs from '../Images/work-leg.png'
import works_heads from '../Images/work-head.png'
import works_arms from '../Images/work-arms.png'

import galleryArmTemp from '../Images/temparm.png'

import Api from '../Utils/apiAdapter.js';

const api = new Api();

const fullFilterData = JSON.parse('{"Arms":{"Arm": ["Tattoo D", "Tattoo E", "Grabinator", "Muscle E", "Wrinkly D", "Human C", "Alien Green", "Bear", "Tattoo A", "Mummy", "Seal", "Gorilla", "Wrinkly B", "Muscle D", "Human D", "Wrinkly E", "Dog", "Alien Yellow", "Wrinkly C", "Reptile", "Human A", "Human E", "Human B", "Tattoo B", "Alien Orange", "Muscle B", "T-Rex", "Cat", "Vines", "Alien Purple", "Bull", "Muscle C", "Wrinkly A", "Stone", "Diamond", "Tattoo C", "Slime", "Ghoul", "Robot", "Golem", "Fish Scale", "Snowman", "Muscle A", "Gold", "Alien Blue", "Octopus", "Inside Out", "Skeleton", "Zombie"], "Item": ["Money Bag", "Dollar", "BTC", "Green Fabergé Egg", "Euro", "Mystery Pickle", "Poker Chip Blue", "Royal Scepter", "Poker Chip Red", "Gold Coins", "GME Stock", "Ledger", "DOGE", "Green Candlesticks", "Seven", "Adventure Map", "Black Card", "Red Fabergé Egg", "Treasure Map", "Golden Statue", "Emerald", "Ruby", "Diamond", "Champagne", "Poker Chip Green", "Goonies Key", "ETH", "Sapphire", "Gold Faberge Egg", "Burning Fiat", "Gold Bar", "Rupee", "Dirty Martini", "Casino Dice", "Piggy Bank", "Crab - Diamond", "Holy Grail", "AMC Stock", "Lambo Key", "Gold Casino Dice", "Silver Skull", "Golden Skull", "VIP Card", "Crab - Burning Fiat", "Crab - Green Faberge Egg", "Crab - Golden Skull"], "Wrist": ["Golden Bracelet - Skulls", "Corded Bracelet", "Gold Watch", "Wooden Watch - Front", "Wooden Watch", "Snap Bracelet", "Golden Bracelet - Emeralds", "Rainbow Bracelet", "Gold Square Bracelet", "Silver Watch", "Sinew Bracelet", "Silver Beaded Bracelet", "Gold Watch - Front", "Circled Bracelet", "Silver Bracelet - Skulls", "Silver Watch - Front", "Silver Bracelet - Emeralds", "Gold Beaded Bracelet", "Gold Bracelet", "Golden Bracelet"], "Background": ["Blue", "Gold", "Pink", "Teal", "Green", "Light Teal", "Silver", "Light Purple", "Purple", "Orange", "Light Pink", "Light Green", "Light Yellow", "Light Orange", "Yellow", "Light Blue"], "Ring": ["Emerald", "Cash", "Ethereum", "Skull", "Heart", "Bitcoin", "Ruby", "Doge", "Illuminati", "Gold Skull", "Diamond", "Sapphire"], "Fingernails": ["Red Dog", "Gold Cat", "Doge", "Red Cow", "Red Bear", "Red Unicorn", "Pink Cat", "Pink Dog", "Watermelon", "Pink Sprinkles", "Gold Bear", "Pink Bear", "Pink Unicorn", "Gold Cow", "Gold Sprinkles", "Pink Cow", "Red Sprinkles", "Red Cat", "Rainbow Unicorn", "Rainbow", "Gold Dog", "Gold Unicorn", "Jason", "Blood"]}}');

const types = ["Arms", "Legs", "Head", "Grabatar"];

// ---------------------------------------------------------------------------------------
// ---------------------------------------------------------------------------------------
// ---------------------------------------------------------------------------------------

function Gallery(props) {

  const[selectedType, setSelectedType] = useState(0);
  const[filterData, setFilterData] = useState(fullFilterData[types[selectedType]]);
  const[filters, setFilters] = useState({});
  const[apiData, setAPIData] = useState([]);
  const[needsUpdate, setNeedsUpdate] = useState(true);
  const[page, setPage] = useState(0);
  const[prevPageDisabled, setPrevPageDisabled] = useState(true);
  const[nextPageDisabled, setNextPageDisabled] = useState(true);
  
  useEffect(() => {
    if (!apiData.length === 0 || needsUpdate) {
        getGalleryData(); // update
        setNeedsUpdate(false); // disable updates
    }else{
        getButtonState();
    }
  })

  const resetButtons = () => {
    setPage(0);
    setPrevPageDisabled(true);
    setNextPageDisabled(true);
  }

  const pageBtnClick = (type) => {
    // disable our buttons
    setPrevPageDisabled(true);
    setNextPageDisabled(true);
    // set that we need an update
    setNeedsUpdate(true);
    // change our page num
    if(type === "prev") {
      setPage(page-1);
    }else{
      setPage(page+1);
    }
    // get new data
    getGalleryData();
  }

  const getButtonState = () => {
    if(page === 0) {
      setPrevPageDisabled(true);
    }else{
      setPrevPageDisabled(false);
    }
    if(apiData.totalCount-(apiData.page*50)>50) {
      setNextPageDisabled(false);
    }else{
      setNextPageDisabled(true);
    }
  };

  const cleanObj = (obj) => {
      for (var propName in obj) {
        if (obj[propName] === null || obj[propName] === undefined || obj[propName] == "") {
          delete obj[propName];
        }
      }
      return obj
  };

  const getGalleryData = async () => {
    if(needsUpdate) {
        // disable updates
        setNeedsUpdate(false); 
        // get params
        let cleanFilters = cleanObj(filters);
        let params = encodeURIComponent(JSON.stringify(cleanFilters));
        // fetch our data
        let response = await api.get('gallery', params, page)
        setAPIData(response);
    }
  };

  const buildGallery = () => {

      if(needsUpdate) {
          getGalleryData();
      }

      if(!apiData.gallery) {
        return (null);
      }

      let colSet = [];
      let reset = false;

      return apiData.gallery.map((element, idx) => {

            if(reset) {
              colSet = [];
              reset = false;
            }

            let nftUrl = "/nft/"+types[selectedType].toLowerCase()+"/"+element["id"];
            // let ipfsImgHash = "https://ipfs.io/ipfs/"+element["image"].replace("ipfs://","");
            let ipfsImgHash = "https://grabatars.com/images/"+types[selectedType].toLowerCase()+"/"+element["id"]+".png"

            if(element["id"] == "1") {
                colSet.push(<Grid.Column><p class="centered"><a href={nftUrl}><video class="ui small centered image" style={{ border: "3px solid gold" }}><source src="/images/arms/1.mov"></source></video><span style={{ color:"gold", fontSize:"20px", fontFamily:"Lobster", display: "block" }}> { element["id"] } </span></a></p></Grid.Column>);
            }else{
                colSet.push(<Grid.Column><p class="centered"><a href={nftUrl}><Image src={ipfsImgHash} centered={true} size="small" style={{ border: "3px solid gold" }} /><span style={{ color:"gold", fontSize:"20px", fontFamily:"Lobster", display: "block" }}> { element["id"] } </span></a></p></Grid.Column>);
            }

            if(((idx+1)%4 === 0) || apiData.gallery.length-1 === idx ) {
              reset = true;
              return(<Grid columns={4} padded>{colSet}</Grid>)
            }

      });

  };

  const handleDropDownSelect = (e, data) => {
      // reset pages
      resetButtons();
      // change our filters
      let tmpFilters = filters;
      tmpFilters[data.placeholder.toLowerCase()] = data.value;
      setFilters(tmpFilters);
      // set that we need an update
      setNeedsUpdate(true);
      // update our gallery
      getGalleryData();
  }

  const buildDropDowns = () => {
    let dropdowns = [];
    Object.keys(filterData).forEach(item => {
      let filterOptions = [];
      Object.keys(filterData[item]).forEach(filterDataItem => {
        filterOptions.push(
          {
            "key": filterData[item][filterDataItem],
            "text": filterData[item][filterDataItem],
            "value": filterData[item][filterDataItem]
          }
        )
      });
      dropdowns.push(
        <Dropdown 
            style={{ background: "none", borderBottom: "2px solid gold", marginBottom: "20px" }}
            placeholder = { item }
            fluid
            search
            selection
            clearable
            options = { filterOptions }
            onChange = { handleDropDownSelect }
        />
      );
    });
    return (dropdowns);
  }

    return (
        <Grid fluid className="mainView">

            <MenuDisp states={{ ...props.states }}/>

            <Grid.Row centered>
                <Container>
                    
                    <h1>Gallery</h1>
                    
                    <Grid columns='equal'>
                    
                        <Grid.Column width={4}>
                        
                            <Grid columns='equal'>

                              <Grid.Column centered={true}>
                                <p class="centered" style={{ margin: "5px" }}>
                                    <Image src={works_arms} style={{ cursor: "pointer", border: "1px solid gold", background: "rgba(0,0,0,0.2)", borderRadius: "25px", padding: "10px" }} centered={true} size="tiny" />
                                    <span style={{ fontFamily: "Lobster" }}>Arms</span>
                                </p>
                              </Grid.Column>
                              <Grid.Column centered={true}>
                                <p class="centered" style={{ margin: "5px" }}>
                                    <Image src={works_legs} style={{ cursor: "not-allowed", border: "1px solid silver", background: "rgba(0,0,0,0.2)", borderRadius: "25px", padding: "10px", opacity: "0.1" }} centered={true} size="tiny" />
                                    <span style={{ fontFamily: "Lobster" }}>Legs</span>
                                </p>
                              </Grid.Column>
                              <Grid.Column centered={true}>
                                <p class="centered" style={{ margin: "5px" }}>
                                    <Image src={works_heads} style={{ cursor: "not-allowed", border: "1px solid silver", background: "rgba(0,0,0,0.2)", borderRadius: "25px", padding: "10px", opacity: "0.1" }} centered={true} size="tiny" />
                                    <span style={{ fontFamily: "Lobster" }}>Head</span>
                                </p>
                              </Grid.Column>
                              <Grid.Column centered={true}>
                                <p class="centered" style={{ margin: "5px" }}>
                                    <Image src={works_grabatar} style={{ cursor: "not-allowed", border: "1px solid silver", background: "rgba(0,0,0,0.2)", borderRadius: "25px", padding: "10px", opacity: "0.1" }} centered={true} size="tiny" />
                                    <span style={{ fontFamily: "Lobster" }}>Grabatar</span>
                                </p>
                              </Grid.Column>

                            </Grid>

                            { buildDropDowns() }

                        </Grid.Column>

                        <Grid.Column>
                        
                            <Grid.Row centered={true} style={{ height: "100px", paddingTop: "25px" }}>
                                <Button color="gold" content="Previous Page" icon="arrow alternate circle left outline" labelPosition="left" disabled={prevPageDisabled} onClick={() => pageBtnClick("prev")} />
                                <Button color="gold" content="Next Page" icon="arrow alternate circle right outline" labelPosition="right" disabled={nextPageDisabled} onClick={() => pageBtnClick("next")} />
                            </Grid.Row>
                            
                            { buildGallery() }

                            <Grid.Row centered={true} style={{ height: "100px", paddingTop: "25px" }}>
                                <Button color="gold" content="Previous Page" icon="arrow alternate circle left outline" labelPosition="left" disabled={prevPageDisabled} onClick={() => pageBtnClick("prev")} />
                                <Button color="gold" content="Next Page" icon="arrow alternate circle right outline" labelPosition="right" disabled={nextPageDisabled} onClick={() => pageBtnClick("next")} />
                            </Grid.Row>

                        </Grid.Column>
                        
                    </Grid>

                </Container>
            </Grid.Row>
        </Grid>
    );
}

export default Gallery;
